import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { auditLeagueIntroduction } from '@/api/gmToolNew/gmToolNew';
import { gmToolNew, gmToolNewCom } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewCom],
  props: {
    propsData: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      dialogShow: false,
      paramsData: {
        id: '',
        uids: '',
        is_abnormal_op: false,
        op_type: 0,
        server_id: '',
        reason: '',
        status: ''
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data, type) {
      this.dialogShow = true;

      if (data) {
        this.paramsData.id = data.id || '';
        this.paramsData.env_id = data.env_id;
        this.paramsData.server_id = data.server_id;
        this.paramsData.league_id = data.league_id;
        this.paramsData.introduction = data.introduction;
        this.paramsData.status = 2;
      }
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      this.paramsData = {
        id: '',
        env_id: '',
        introduction: '',
        league_id: '',
        server_id: '',
        status: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;

      var data = JSON.parse(JSON.stringify(this.paramsData));
      auditLeagueIntroduction(_objectSpread(_objectSpread({}, data), {}, {
        env_id: this.propsData.env_id
      })).then(function (res) {
        if (res.code == 200) {
          _this.$message({
            message: _this.$t('operationSuccess'),
            type: 'success'
          });

          _this.dialogShow = false;

          _this.$emit('change');
        }
      });
    }
  }
};